import fileToArrayBuffer from 'file-to-array-buffer'
import { PDFDocument } from 'pdf-lib'

async function extractPagesFromPdf(file, firstPage, lastPage) {
  const fileArrayBuffer = await fileToArrayBuffer(file)

  const pages = []
  let page = firstPage - 1
  do {
    pages.push(page)
    page++
  } while (page <= lastPage - 1)

  const pdfDoc = await PDFDocument.load(fileArrayBuffer)
  const pdfItem = await PDFDocument.create()
  const pdfPages = await pdfItem.copyPages(pdfDoc, pages)
  for (const p of pdfPages) {
    await pdfItem.addPage(p)
  }
  const pdfChunk = await pdfItem.save()
  const blob = new Blob([pdfChunk.buffer], { type: 'application/pdf' })
  return new File([blob], 'chunk.pdf')
}

export default {
  extractPagesFromPdf,
}
